export default "__VITE_ASSET__CuiRcXtX__"